import { render, staticRenderFns } from "./TemplateSelect.vue?vue&type=template&id=9dee8d24"
import script from "./TemplateSelect.vue?vue&type=script&lang=js"
export * from "./TemplateSelect.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelect.vue?vue&type=style&index=0&id=9dee8d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports